import { useTranslation } from "react-i18next";
import { Download } from "lucide-react";
import CopyText from "../../CopyText/CopyText";

interface StoreCommissionPanelHeaderProps {
  shareLink: string;
  pdfUrl?: string | null;
}

export default function StoreCommissionPanelHeader({
  shareLink,
  pdfUrl,
}: StoreCommissionPanelHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3 mb-2">
      <CopyText text={shareLink} />
      <span className="text-xs text-muted-foreground mr-2">
        {t("store_commission_panel.share_with_customer") || "Share with the customer"}
      </span>
      {pdfUrl && (
        <a
          href={pdfUrl}
          download
          className="flex items-center text-xs text-blue-600 underline hover:text-blue-800 ml-2 gap-1"
        >
          <Download className="h-4 w-4" />
          {t("store_commission_panel.download_pdf_contract") || "Download PDF contract"}
        </a>
      )}
    </div>
  );
}
